import http from '../lib/http';

export const CHOOSE_OFFER = 'CHOOSE_OFFER';

export const FETCH_OFFERS_ERROR = 'FETCH_OFFERS_ERROR';
export const FETCH_OFFERS_START = 'FETCH_OFFERS_START';
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS';

export function chooseOffer(offerId) {
    return {
        type: CHOOSE_OFFER,
        payload: offerId
    };
}

export function fetchOffers(barId) {
    return {
        type: 'FETCH_OFFERS',
        payload: {
            promise: getOffers(barId)
        }
    };
}

async function getOffers(barId) {
    const res = await http.get(`/app/offers/${barId}`);
    if (res.status < 300) return res.json();
    throw res.json();
}



// WEBPACK FOOTER //
// ./src/common/offers/actions.js